import { useEffect } from "react";
import "@/App.css";
import { Shield, FileText, Download } from "lucide-react";

const PrivacyPage = () => {
  useEffect(() => {
    document.title = "EduPlan - Politique de Confidentialité";
  }, []);

  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <header className="border-b border-border bg-card">
        <div className="container mx-auto px-4 py-6">
          <div className="flex items-center gap-3">
            <img
              src="/logo-eduplan.png"
              alt="EduPlan Logo"
              className="h-12 w-auto"
            />
            <div>
              <h1 className="text-2xl font-bold text-foreground">EduPlan</h1>
              <p className="text-sm text-muted-foreground">LinkSync - Solutions éducatives</p>
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="container mx-auto py-12 px-4 max-w-4xl">
        {/* Title Section */}
        <div className="flex items-center gap-4 mb-8">
          <div className="bg-primary/10 p-4 rounded-lg">
            <Shield className="h-12 w-12 text-primary" />
          </div>
          <div>
            <h2 className="text-3xl font-bold text-foreground mb-2">
              ACCORD-CADRE DE FOURNITURE DE SERVICES SAAS - EDUPLAN - LINKSYNC I RGPD
            </h2>
            <p className="text-muted-foreground">Protection de vos données personnelles</p>
          </div>
        </div>

        {/* Document Card */}
        <div 
          data-slot="card" 
          data-testid="document-card"
          className="bg-card text-card-foreground flex flex-col gap-6 rounded-xl border py-6 shadow-sm mb-8"
        >
          <div data-slot="card-header" className="grid auto-rows-min items-start gap-2 px-6">
            <div data-slot="card-title" className="leading-none font-semibold flex items-center gap-2 text-foreground">
              <FileText className="h-5 w-5 text-primary" />
              Document RGPD
            </div>
            <div data-slot="card-description" className="text-muted-foreground text-sm">
              Accord-cadre de fourniture de services SaaS - EduPlan &amp; LinkSync
            </div>
          </div>

          <div data-slot="card-content" className="px-6 space-y-6">
            <div className="bg-muted/30 p-6 rounded-lg space-y-3 text-foreground">
              <p className="leading-relaxed">
                Ce document détaille nos engagements en matière de protection des données personnelles 
                conformément au Règlement Général sur la Protection des Données (RGPD).
              </p>
              <p className="leading-relaxed">Il comporte les documents suivants :</p>
              <ul className="list-disc list-inside space-y-2 ml-4 text-foreground/90">
                <li>ACCORD-CADRE DE FOURNITURE DE SERVICES SAAS</li>
                <li>CONDITIONS GÉNÉRALES D'UTILISATION (CGU)</li>
                <li>CONDITIONS GÉNÉRALES DE VENTE (CGV)</li>
                <li>POLITIQUE DE CONFIDENTIALITÉ</li>
                <li>DATA PROCESSING AGREEMENT (DPA)</li>
                <li>Analyse d'Impact relative à la Protection des Données (DPIA / PIA)</li>
              </ul>
            </div>

            {/* Download Button */}
            <div className="border-t border-border pt-6">
              <a
                href="/politique-confidentialite.pdf"
                download="ACCORD-CADRE-EDUPLAN-LINKSYNC.pdf"
                data-testid="download-pdf-btn"
                className="inline-flex items-center justify-center whitespace-nowrap text-sm font-medium transition-all bg-primary text-primary-foreground hover:bg-primary/90 h-10 rounded-md px-6 w-full sm:w-auto gap-2"
              >
                <Download className="h-5 w-5" />
                Télécharger la politique complète (PDF)
              </a>
            </div>

            {/* Company Info */}
            <div className="border-t border-border pt-6 space-y-2 text-sm text-muted-foreground">
              <p><strong className="text-foreground">Société :</strong> LinkSync</p>
              <p><strong className="text-foreground">Adresse :</strong> 18 rue du 11 novembre, 14000 Caen</p>
              <p><strong className="text-foreground">SIRET :</strong> 984 999 334 00019</p>
              <p><strong className="text-foreground">Dernière mise à jour :</strong> 03 février 2026</p>
            </div>
          </div>
        </div>

        {/* Contact Card */}
        <div 
          data-slot="card" 
          data-testid="contact-card"
          className="text-card-foreground flex flex-col gap-6 rounded-xl border py-6 shadow-sm bg-muted/30"
        >
          <div data-slot="card-header" className="grid auto-rows-min items-start gap-2 px-6">
            <div data-slot="card-title" className="leading-none font-semibold text-foreground">
              Besoin d'informations supplémentaires ?
            </div>
          </div>
          <div data-slot="card-content" className="px-6 text-foreground/90">
            <p className="mb-4 leading-relaxed">
              Pour toute question concernant notre politique de confidentialité ou vos données personnelles, 
              n'hésitez pas à nous contacter.
            </p>
            <p className="text-sm text-muted-foreground">Email : contact@linksync.fr</p>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t border-border mt-12 bg-card">
        <div className="container mx-auto px-4 py-6 text-center text-sm text-muted-foreground">
          <p>© 2026 LinkSync - EduPlan. Tous droits réservés.</p>
        </div>
      </footer>
    </div>
  );
};

function App() {
  return <PrivacyPage />;
}

export default App;
